import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { ComparableSalesPageComponent } from './comparable-sales.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: ComparableSalesPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ComparableSalesPageRoutingModule {}
